import React from 'react';
import Button from "react-bootstrap/lib/Button";
import {API_URL} from "../constants";

function BrochureTab() {
    return (
        <div>
            <p>Here you can download the brochure of the conference in a spreadsheet format:</p>

            <a href={API_URL + '/admin/brochure'}>
                <Button bsStyle="success">Get brochure</Button>
            </a>
        </div>
    )
}

export default BrochureTab
